import * as urlUtils from 'utils/Url';

// Data Mapping
export function getPathAddDataMapping() {
  return `/data-mappings/add`;
}

export function getPathEditDataMapping(dmapId) {
  return `/data-mappings/${dmapId}/edit`;
}

export function getPathReplicateDataMapping(dmapId) {
  return `/data-mappings/${dmapId}/replicate`;
}

export function getPathPredefinedDataMappings(qs={}) {
  return urlUtils.appendQueryString(`/predefined-data-mappings`, qs);
}

export function getPathCustomDataMappings(qs={}) {
  return urlUtils.appendQueryString(`/custom-data-mappings`, qs);
}


// Lookup Table
export function getPathPredefinedLookupTables(qs={}) {
  return urlUtils.appendQueryString(`/predefined-lookup-tables`, qs);
}

export function getPathCustomLookupTables(qs={}) {
  return urlUtils.appendQueryString(`/custom-lookup-tables`, qs);
}

export function getPathLookupTableColumns(tableId, qs={}) {
  return urlUtils.appendQueryString(`/lookup-tables/${tableId}/columns`, qs);
}

export function getPathLookupTableRecords(tableId, qs={}) {
  return urlUtils.appendQueryString(`/lookup-tables/${tableId}/records`, qs);
}


// Background Job
export function getPathBackgroundJobs(qs={}) {
  return urlUtils.appendQueryString(`/background-jobs`, qs);
}

export function getPathBackgroundJobLogs(jobId, qs={}) {
  return urlUtils.appendQueryString(`/background-jobs/${jobId}/logs`, qs);
}


// Import Job
export function getPathImportJobs(qs={}) {
  return urlUtils.appendQueryString(`/import-jobs`, qs);
}

export function getPathAddImportJob() {
  return `/import-jobs/add`;
}

export function getPathPreviewImportJob(jobId) {
  return `/import-jobs/${jobId}/preview`;
}

export function getPathImportJobLogs(jobId, qs={}) {
  return urlUtils.appendQueryString(`/import-jobs/${jobId}/logs`, qs);
}


// Export Job
export function getPathExportJobs(qs={}) {
  return urlUtils.appendQueryString(`/export-jobs`, qs);
}


// CSV Schemas
export function getPathCsvSchemas(qs={}) {
  return urlUtils.appendQueryString(`/csv-schemas`, qs);
}

export function getPathCsvSchemaDetails(schemaKey) {
  return `/csv-schemas/${schemaKey}/details`;
}


// Taxonomy
export function getPathTaxonomies(qs={}) {
  return urlUtils.appendQueryString(`/taxonomies`, qs);
}

export function getPathTaxonomyRecords(taxonomyKey, qs={}) {
  return urlUtils.appendQueryString(`/taxonomies/${taxonomyKey}/records`, qs);
}
